<br><p-fieldset legend="Decretos de Nomeação" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="portNomeacaoJunta"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Atas" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="atajuntaderecursos"></app-lista-arquivos>
</p-fieldset>